import { SerialisableModel } from '../Model';
export class SubEntityModel extends SerialisableModel {
    static from(data) {
        return new SubEntityModel(data);
    }
    get entityId() {
        return this.data.parent_entity_id;
    }
    get entityName() {
        return this.data.parent_entity_trading_name;
    }
    get id() {
        return this.data.sub_entity_id;
    }
    get name() {
        return this.data.legal_name;
    }
    get referenceNumber() {
        return this.data.reference_number;
    }
    get status() {
        return this.data.status;
    }
}
